import { Box, Chip, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';
import { WEBHOOK_EVENTS } from '../constants/webhook-events';
import { eventChoiceSx } from './integration-list.styles';

interface Props {
    value: number[];
    error: boolean;
    onChange: (events: number[]) => void;
}

/// Eventos que disparam o aviso; cada etiqueta liga e desliga um.
export const WebhookEventPicker = ({ value, error, onChange }: Props) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    const toggle = (event: number) =>
        onChange(value.includes(event) ? value.filter((item) => item !== event) : [...value, event]);

    return (
        <Box>
            <Typography variant="caption" sx={{ color: cc.textSecondary, display: 'block', mb: 0.75 }}>
                {t('webhooks.quandoAvisar')}
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {WEBHOOK_EVENTS.map((item) => {
                    const on = value.includes(item.value);

                    return (
                        <Chip
                            key={item.value}
                            label={t(item.key)}
                            icon={on ? <CheckIcon /> : undefined}
                            onClick={() => toggle(item.value)}
                            sx={eventChoiceSx(cc, on)}
                        />
                    );
                })}
            </Box>

            {error && (
                <Typography sx={{ fontSize: 11.5, color: cc.eventDanger, mt: 0.75 }}>
                    {t('webhooks.escolhaUmEvento')}
                </Typography>
            )}
        </Box>
    );
};
